"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

exports.__esModule = true;

var React = __importStar(require("react"));

var constants_1 = require("../constants");

var isMediaSessionSupported = function isMediaSessionSupported() {
  return 'mediaSession' in navigator;
};

var setMediaSession = function setMediaSession(props) {
  if (!isMediaSessionSupported() || !props.programTitle) {
    return;
  }

  var title = props.episodeTitle ? props.programTitle + " - " + props.episodeTitle : props.programTitle;
  var artwork = props.poster ? [{
    src: props.poster,
    sizes: '',
    type: 'image/jpg'
  }] : [];
  navigator.mediaSession.metadata = new MediaMetadata({
    title: title,
    artist: '',
    album: '',
    artwork: artwork
  });
};

var isStarted = function isStarted(playerState) {
  return playerState === constants_1.PlayerState.PLAYING || playerState === constants_1.PlayerState.PAUSED || playerState === constants_1.PlayerState.SEEKING || playerState === constants_1.PlayerState.BUFFERING;
};

var wasJustStarted = function wasJustStarted(playerState, prevPlayerState) {
  return playerState === constants_1.PlayerState.PLAYING && prevPlayerState === constants_1.PlayerState.LOADED;
};
/**
 * Determine if a prop changed that would impact any media session metadata.
 */


var displayPropChanged = function displayPropChanged(props, prevProps) {
  return props.episodeTitle !== prevProps.episodeTitle || props.programTitle !== prevProps.programTitle || props.poster !== prevProps.poster;
};

var MediaSessionManager =
/** @class */
function (_super) {
  __extends(MediaSessionManager, _super);

  function MediaSessionManager() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MediaSessionManager.prototype.componentDidUpdate = function (prevProps) {
    // Quick abort if Media Session API is not available.
    if (!isMediaSessionSupported()) {
      return;
    }

    if (wasJustStarted(this.props.playerState, prevProps.playerState) || isStarted(this.props.playerState) && displayPropChanged(this.props, prevProps)) {
      setMediaSession(this.props);
    }
  };

  MediaSessionManager.prototype.render = function () {
    return null;
  };

  return MediaSessionManager;
}(React.Component);

exports["default"] = MediaSessionManager;